import mitt from 'mitt'
import { isString } from 'es-toolkit'

export interface ApplicationEvents {
  'app:layout:created': void
  'app:layout:mounted': void
  'app:search:value:updated': string
  'movie:favorite:updated': { kinopoiskId: number, isFavorite: boolean }
  [key: string | symbol]: any
}

export default defineNuxtPlugin({
  name: 'app:eventBus',
  dependsOn: ['app:grpc-instance'],

  async setup({ $config }) {
    const emitter = mitt<ApplicationEvents>()
    const logger = useConsole()

    if (!$config.public.APP_IS_PROD && $config.public.APP_DEBUG) {
      emitter.on('*', (type, e: unknown) => {
        if (!isString(type)) {
          return logger.info('bus', type.toString(), e)
        }
        if (e) {
          logger.info('bus', `${type}`, e)
        } else {
          logger.info('bus', `${type}`)
        }
      })
    }

    return {
      provide: {
        bus: {
          emit: emitter.emit,
          on: emitter.on,
          off: emitter.off,
        },
      },
    }
  },
})
